import { Dto, DtoWithId } from "@mango/core";
import { Factuur } from './factuur';

@Dto({fullName: "CIJBorculo.Logic.FactuurStatusHistorie"})
export class FactuurStatusHistorie extends DtoWithId {
	factuur: Factuur;
	status: string;
	op: Date;
	door: string;
}